import React from 'react'
import { useIntl } from 'react-intl'

import { Section } from '../../components/Section'
import { SectionLastCTA } from '../../components/SectionLastCTA'
import { SlitePage } from '../../components/SlitePage'
import { TextLayout } from '../../components/TextLayout'
import { useRoutes } from '../../routes'
import { FeaturesSectionManage } from './SectionManage'

export default function FeaturesPage() {
  const intl = useIntl()
  const routes = useRoutes()
  const title = intl.formatMessage({
    id: 'features.page.title',
    defaultMessage: 'Slite - How it works',
  })

  const description = intl.formatMessage({
    id: 'features.page.description',
    defaultMessage:
      'Discover features that will keep your team organized and aligned. A sleek editor, ability to share docs with anyone, collaboration features such as comments and mentions.',
  })

  return (
    <SlitePage
      canonicalUrl={routes.features()}
      title={title}
      description={description}
      ogImage="https://cdn.sanity.io/images/dnsgqii5/production/7d44dbe6a0d88160dd10fd1ecfac384304d3705e-1200x630.jpg"
      background="moon-dust"
    >
      <Section background="moon-dust" containerTopPadding={120}>
        <TextLayout
          type="centered"
          title={intl.formatMessage({
            id: 'features.page.heroTitle',
            defaultMessage: 'Keep your knowledge fresh.',
          })}
          titleMaxWidth={1000}
          description={intl.formatMessage({
            id: 'features.page.heroSubtitle',
            defaultMessage:
              'No more repetitive questions from your team to check if information is still accurate or manual work for you to keep docs relevant. Enjoy AI-driven insights that show which docs require your attention and act on them in bulk—all from one central panel.',
          })}
          descriptionMaxWidth={500}
        />
      </Section>
      <FeaturesSectionManage />
      <SectionLastCTA background="moon-dust" />
    </SlitePage>
  )
}
